import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_WARD_FAILURE,
  ADD_WARD_REQUEST,
  ADD_WARD_SUCCESS,
  DELETE_WARD_FAILURE,
  DELETE_WARD_REQUEST,
  DELETE_WARD_SUCCESS,
  FETCH_LIST_ALL_WARD_FAILURE,
  FETCH_LIST_ALL_WARD_REQUEST,
  FETCH_LIST_ALL_WARD_SUCCESS,
  FETCH_LIST_ALLS_WARD_FAILURE,
  FETCH_LIST_ALLS_WARD_REQUEST,
  FETCH_LIST_ALLS_WARD_SUCCESS,
  FETCH_LIST_WARD_FAILURE,
  FETCH_LIST_WARD_REQUEST,
  FETCH_LIST_WARD_SUCCESS,
  FETCH_LIST_WEEK_ID_FAILURE,
  FETCH_LIST_WEEK_ID_REQUEST,
  FETCH_LIST_WEEK_ID_SUCCESS,
  FETCH_WARD_FAILURE,
  FETCH_WARD_REQUEST,
  FETCH_WARD_SUCCESS,
  RESET_CURRENT_WARD,
  UPDATE_WARD_FAILURE,
  UPDATE_WARD_REQUEST,
  UPDATE_WARD_SUCCESS,
} from "./wardType";

const initialState = {
  wards: [],
  currentWard: null,
  fetchAllWards: { ...defaultStatus },
  fetchAllWard: { ...defaultStatus },
  fetchWards: { ...defaultStatus },
  fetchWard: { ...defaultStatus },
  fetchWeekId: { ...defaultStatus },
  addWard: { ...defaultStatus },
  updateWard: { ...defaultStatus },
  deleteWard: { ...defaultStatus },
  formMode: null,
};

const wardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    // List Wards

    case FETCH_LIST_ALLS_WARD_REQUEST:
      return {
        ...state,
        fetchAllWard: { ...state.fetchAllWard, inProgress: true },
      };
    case FETCH_LIST_ALLS_WARD_SUCCESS:
      return {
        ...state,
        fetchAllWard: {
          ...state.fetchAllWard,
          success: true,
          inProgress: false,
          wards: payload?.wards?.data,
        },
      };
    case FETCH_LIST_ALLS_WARD_FAILURE:
      return {
        ...state,
        fetchAllWard: {
          ...state.fetchAllWard,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_LIST_ALL_WARD_REQUEST:
      return {
        ...state,
        fetchAllWards: { ...state.fetchAllWards, inProgress: true },
      };
    case FETCH_LIST_ALL_WARD_SUCCESS:
      return {
        ...state,
        fetchAllWards: {
          ...state.fetchAllWards,
          success: true,
          inProgress: false,
          wards: payload?.wards?.data,
        },
      };
    case FETCH_LIST_ALL_WARD_FAILURE:
      return {
        ...state,
        fetchAllWards: {
          ...state.fetchAllWards,
          error: true,
          errorMessage: payload.error,
        },
      };

    // List Wards
    case FETCH_LIST_WARD_REQUEST:
      const { blockId, floorId, pageNo } = payload;
      return {
        ...state,
        fetchWards: {
          ...state.fetchWards,
          inProgress: true,
          blockId,
          floorId,
          pageNo,
        },
      };
    case FETCH_LIST_WARD_SUCCESS:
      return {
        ...state,
        fetchWards: {
          ...state.fetchWards,
          success: true,
          inProgress: false,
          wards: payload?.wards?.data,
        },
      };
    case FETCH_LIST_WARD_FAILURE:
      return {
        ...state,
        fetchWards: {
          ...state.fetchWards,
          error: true,
          errorMessage: payload.error,
        },
      };

    // View single Ward
    case FETCH_WARD_REQUEST:
      return {
        ...state,
        fetchWard: { ...state.fetchWard, inProgress: true },
      };
    case FETCH_WARD_SUCCESS:
      return {
        ...state,
        fetchWard: { ...state.fetchWard, success: true, inProgress: false },
        currentWard: payload.ward,
      };
    case FETCH_WARD_FAILURE:
      return {
        ...state,
        fetchWard: {
          ...state.fetchWard,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_LIST_WEEK_ID_REQUEST:
      return {
        ...state,
        fetchWeekId: { ...state.fetchWeekId, inProgress: true },
      };
    case FETCH_LIST_WEEK_ID_SUCCESS:
      return {
        ...state,
        fetchWeekId: {
          ...state.fetchWeekId,
          success: true,
          error: false,
          inProgress: false,
          data: payload?.ward?.data,
        },
      };
    case FETCH_LIST_WEEK_ID_FAILURE:
      return {
        ...state,
        fetchWeekId: {
          ...state.fetchWeekId,
          error: true,
          errorMessage: payload.error,
        },
      };
    // Add Ward
    case ADD_WARD_REQUEST:
      return {
        ...state,
        addWard: { ...state.addWard, inProgress: true },
      };
    case ADD_WARD_SUCCESS:
      return {
        ...state,
        addWard: {
          ...state.addWard,
          success: true,
          error: false,
          inProgress: false,
          data: payload?.ward,
        },
      };
    case ADD_WARD_FAILURE:
      return {
        ...state,
        addWard: {
          ...state.addWard,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload,
        },
      };

    // Edit Ward
    case UPDATE_WARD_REQUEST:
      return {
        ...state,
        updateWard: { ...state.updateWard, inProgress: true },
      };
    case UPDATE_WARD_SUCCESS: {
      return {
        ...state,
        updateWard: {
          ...state.updateWard,
          inProgress: false,
          success: true,
          error: false,
          data: payload?.ward,
        },
      };
    }
    case UPDATE_WARD_FAILURE:
      return {
        ...state,
        updateWard: {
          ...state.updateWard,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.errorMessage,
        },
      };

    // Delete Ward
    case DELETE_WARD_REQUEST:
      return {
        ...state,
        deleteWard: { ...state.deleteWard, inProgress: true },
      };
    case DELETE_WARD_SUCCESS:
      return {
        ...state,
        deleteWard: { ...state.deleteWard, success: true, inProgress: false },
        wards: state.wards.filter((ward) => ward.id !== payload.wardId),
        currentWard:
          state.currentWard?.id === payload.wardId ? null : state.currentWard,
      };
    case DELETE_WARD_FAILURE:
      return {
        ...state,
        deleteWard: {
          ...state.deleteWard,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Reset current Ward
    case RESET_CURRENT_WARD:
      return {
        ...state,
        currentWard: null,
      };

    default:
      return state;
  }
};

export default wardReducer;
